import { useContext } from 'react';
import SEOContext from '../context';

const useSEO = () => {
  const value = useContext(SEOContext);

  return value;
};

export default useSEO;